import { Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from './menu.service';

import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {RequestService} from './request.service';
import { Observable } from 'rxjs';


@Injectable()


export class PuentesService {

  constructor(private router: Router,  private _Menu: MenuService, private request: RequestService) {}
  public dataProject: DataProject;

  private on_project_updated: BehaviorSubject<any> = new BehaviorSubject(null);

  public onProjectUpdated(): Observable<any> {
    return this.on_project_updated.asObservable();
  }


  // DEVOLVEMOS LOS DATOS DEL PUENTE SELECCIONADO A PARTIR DEL ID DEL PUENTE
  getDataProject(idProject?, admin?): DataProject {
    if (admin){
      this.request.makeRequest('project', {pid: idProject}).subscribe((d) => {
        this.on_project_updated.next(d);
        this.dataProject = d;
      });
    } else {
      if (idProject) {
        this.request.makeRequest('project', {pid: idProject}).subscribe((d) => {
          this.on_project_updated.next(d);
          this.dataProject = d;
          this.router.navigate(['/pages/general/']);
        });
      } else {
        if (this.dataProject) {
          return this.dataProject;
        } else {
          this.router.navigate(['']);
        }
      }
    }

  }



}


export interface DataProject {
  prod: string;
  project: {
    co_id: number;
    gps_lat: string;
    gps_lon: string;
    id: number;
    ini_date: string;
    end_date: string;
    location: string;
    initial_state_date: string;
    name: string;
    nnodes: number;
    pl_id: string;
    string_identifier: string|null;
    simulations: number;
  };
  sections: {
    id: number;
    image: string;
    lX: number;
    lX2: number;
    lY: number;
    lY2: number;
    label: string;
    position: string;
    position_label: string|null;
    stateSection: number|null;
    ubi_section: string;
    nodes: {
      despl_type: string|null;
      id: number;
      lX: number;
      lY: number;
      label: string;
      ubi_section: string;
      display: string;
      maintainment: string;
      nodeType: {
        axes_count: string;
        chart_title: string;
        chart_xAxis: string;
        chart_yAxis: string;
        id: string;
        label: string;
        precision: string;
        short_label: string;
        unit: string;
        axes_labels: any;
        date_format: string;
      },
      sid: number;
      state: number;
      y_max: number;
      y_min: number;
    }[],
  }[];
}



export interface Puente {
  id: number;
  name: string;
  imgInstalacion: string;
  imgGeneral: string;
  coord:
    {
      x: string;
      y: string;
    };
  state: number;
}




export interface Section {
  sections:
    {
      id: string,
      lX: number,
      lX2: number,
      lY: number,
      lY2: number,
      label: string,
      tramo: string,
      type: string,
      nodes:
        {
          id: string,
          sid: string,
          lX: string,
          lY: string,
          label: string,
          nodeType: string,
          state: number,
          identifier: string,
          despl_type: string|null,
        }[],
    }[];
  }
